export default {
    methods: {
        retornoBruto(porcentagem, investido){
            return porcentagem * investido
        },
        retornoLiquido(bruto, IRTotal){
            return bruto - IRTotal
        },
        GerarCalculos(valorFinanciado, taxaMensal, meses){
            let tabela = [], total = {}
            let valorParcela = this.PMT(valorFinanciado, taxaMensal, meses)
            for (let i = 1; i <= meses; i++) {
                let juros = this.valorJuros(valorFinanciado, taxaMensal)
                let IR = this.valorIR(i, juros)
                let amortizado = this.valorAmortizado(valorParcela, juros)
                let parcelaLiquida = valorParcela - IR
                total = this.contarTaxas({juros, IR}, total)
                valorFinanciado = valorFinanciado - amortizado
    
                let itemTabela = this.formatarCalcJson({ juros, IR, amortizado, parcelaLiquida, valorFinanciado, parcela:i })
    
                tabela = [...tabela, itemTabela]
            }
            total = this.formatarCalcJson(total)
    
            return { tabela, ...total, valorParcela }
        },
        PMT(valorFinanciado, taxaMensal, meses){
            let dividendo = Math.pow((taxaMensal + 1), meses) * taxaMensal
            let divisor = Math.pow((taxaMensal + 1), meses) - 1
            return divisor != 0 ? (valorFinanciado * ( dividendo/divisor )) : valorFinanciado/meses
        },
        valorJuros(valorRestante, taxaMensal){
            return (valorRestante * taxaMensal)
        },
        valorAmortizado(valorParcela, juros){
            return (valorParcela - juros)
        },
        valorIR(mes, juros){
            let IR = 0.15
            if (mes > 0 && mes <= 6) IR = 0.225
            if (mes > 6 && mes <= 12) IR = 0.2
            if (mes > 12 && mes <= 24) IR = 0.175
            return IR * juros
        },
        formatarCalcJson(obj){
            Object.keys(obj).forEach((key)=>{
                key == 'parcela' ? '' : obj[key] = obj[key].toFixed(2)
            });
            return obj
        },
        contarTaxas(obj, countObj){
            Object.keys(obj).forEach((key)=>{
                typeof countObj[key] == 'undefined' ? countObj[key] = 0 : ''
                typeof countObj[key] == 'number' ?
                    countObj[key] = countObj[key] + obj[key] :
                    countObj[key] = parseFloat(countObj[key]) + parseFloat(obj[key])
            });
            return countObj
        },
        
    },
}


// WEBPACK FOOTER //
// ./src/mixins/Calculos.js